import { useCallback, useEffect, useState } from "react";

// material ui
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

// components
import Button from "../../common/button";
import TextInput, { InputType } from "../../forms/textInput";

// styles
import styles from "./styles.module.css";

// constants
import { BUTTON, FORM } from "./constants";

// providers and context
import { AuthConfig } from "../../../setup/context/config/authConfig";

// api
import {
  addUserAddress,
  editUserAddress,
  getUserAllAddress,
} from "../../../setup/api/services/user";
import { ALERTMESSAGE } from "../../../enums";

export enum ALERT {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  NONE = "NONE",
}

const AddressModification = () => {
  const userId = AuthConfig.getUserInfo().id;
  const [addressId, setAddressId] = useState<number | null>();
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [street, setStreet] = useState("");
  const [buildingNumber, setBuildingNumber] = useState("");
  const [postNumber, setPostNumber] = useState("");

  const [loading, setLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<ALERT>(ALERT.NONE);

  const getAddress = useCallback(async () => {
    try {
      const response = await getUserAllAddress(Number.parseInt(userId));
      if (response?.data.length > 0) {
        const currentAddress = response.data[0];
        setAddressId(currentAddress.id);
        setCity(currentAddress?.city);
        setDistrict(currentAddress?.district);
        setStreet(currentAddress?.street);
        setBuildingNumber(currentAddress?.buildingNo);
        setPostNumber(currentAddress?.postalCode || "");
      }
    } catch (error) {
      console.error("error", error);
    }
  }, []);

  useEffect(() => {
    if (userId) getAddress();
  }, [getAddress, userId]);

  const submitEdits = async () => {
    setLoading(true);
    const data = {
      city: city,
      district: district,
      street: street,
      buildingNo: buildingNumber,
      postalCode: postNumber,
      countryCode: "SA",
      addressLabel: "HOME",
    };
    try {
      if (addressId && addressId !== null) {
        try {
          await editUserAddress(Number(addressId), data);
          setAlert(ALERT.SUCCESS);
        } catch (error) {
          setAlert(ALERT.ERROR);
        }
        setLoading(false);
      } else {
        try {
          await addUserAddress(Number(userId), data);
          setAlert(ALERT.SUCCESS);
        } catch (error) {
          setAlert(ALERT.ERROR);
        }
        setLoading(false);
      }
      getAddress();
    } catch (error) {
      setAlert(ALERT.ERROR);
    }
  };

  useEffect(() => {
    if (alert !== ALERT.NONE) {
      setTimeout(() => {
        setAlert(ALERT.NONE);
      }, 2000);
    }
  }, [alert]);

  return (
    <Box className={styles["container"]}>
      <div>
        <Typography className={styles["header"]}>
          {FORM.ADDRESS_DETAIL}
        </Typography>

        <Grid className={styles["form_container"]} container spacing={2}>
          <Grid md={5.95} xs={12}>
            <TextInput
              handleChange={(event) => setCity(event.target.value)}
              label={FORM.CITY}
              defaultValue={city}
              placeholder={FORM.CITY}
            />
          </Grid>
          <Grid xs={0.1} />
          <Grid md={5.95} xs={12}>
            <TextInput
              handleChange={(event) => setDistrict(event.target.value)}
              label={FORM.NEIGHBORHOOD}
              defaultValue={district}
              placeholder={FORM.NEIGHBORHOOD}
            />
          </Grid>
          <Grid xs={12}>
            <TextInput
              handleChange={(event) => setStreet(event.target.value)}
              label={FORM.STREET}
              defaultValue={street}
              placeholder={FORM.STREET}
            />
          </Grid>
          <Grid md={5.95} xs={12}>
            <TextInput
              handleChange={(event) => setBuildingNumber(event.target.value)}
              label={FORM.BUILDING_NUMBER}
              defaultValue={buildingNumber}
              type={InputType.NUMBER}
              placeholder={FORM.BUILDING_NUMBER}
            />
          </Grid>
          <Grid xs={0.1} />
          <Grid md={5.95} xs={12}>
            <TextInput
              handleChange={(event) => setPostNumber(event.target.value)}
              label={FORM.POST_NUMBER}
              type={InputType.NUMBER}
              defaultValue={postNumber}
              placeholder={FORM.POST_NUMBER}
            />
          </Grid>
        </Grid>
        <Button onClick={submitEdits}>
          {loading ? (
            <CircularProgress color="inherit" />
          ) : (
            `${BUTTON.SAVE_EDITS}`
          )}
        </Button>
      </div>
      {alert !== ALERT.NONE && (
        <Alert severity={alert === ALERT.SUCCESS ? "success" : "error"}>
          {alert === ALERT.SUCCESS ? ALERTMESSAGE.SUCCESS : ALERTMESSAGE.ERROR}
        </Alert>
      )}
    </Box>
  );
};

export default AddressModification;
